import React from 'react';

import styled, { keyframes } from 'styled-components';
import { ICONS_MAP, IconType } from './icons';

interface Props {
   id?: string;
   icon: IconType;
   color: string;
   size: string;
   flip?: boolean;
   hovercolor?: string;
   mobilesize?: string;
}

const IconsLib = ({
   id = '',
   icon = 'heart-fill',
   size,
   color,
   flip,
   hovercolor = '',
   mobilesize = '14px',
}: Props) => {
   const IconComponent = ICONS_MAP[icon]; // Dynamically select the icon
   return IconComponent ? (
      <Wrapper
         id={id}
         //    icon={icon}
         flip={flip}
         $hovercolor={hovercolor} // Use transient prop $
         $mobilesize={mobilesize} // Use transient prop $
         size={size}
         color={color}
      >
         <IconComponent
            id={id}
            size={size}
            color={color}
            className={`${icon} ${
               icon === 'loader' ? 'iconlist_item_icon_loader' : ''
            }`}
         />
      </Wrapper>
   ) : null;
};

const spinnerAnimation = keyframes`
   from {transform: rotate(0deg);}
   to {transform: rotate(360deg);}
`;

const Wrapper = styled.div<{
   flip?: boolean;
   color: string;
   size: string;
   $mobilesize: string;
   $hovercolor: string;
}>`
   display: grid;
   line-height: 1.4;
   transform: ${({ flip }) => (flip ? 'scaleX(-1)' : '')};

   .iconlist_item_icon {
      display: block;
      line-height: 0;
      color: ${({ color }) => (color ? color : '')};
      width: ${({ size }) => (size ? size : '20px')};
      height: ${({ size }) => (size ? size : '20px')};
      transition: all 0.3s ease-in-out;
      :hover {
         color: ${({ $hovercolor }) => ($hovercolor ? $hovercolor : ``)};
         transition: all 0.3s ease-in-out;
      }
      @media (max-width: 640px) {
         width: ${({ $mobilesize }) => ($mobilesize ? $mobilesize : '20px')};
         height: ${({ $mobilesize }) => ($mobilesize ? $mobilesize : '20px')};
         transition: all 0.3s ease-in-out;
      }
   }
   .iconlist_item_icon_loader {
      line-height: 0;
      color: ${({ color }) => (color ? color : '')};
      width: ${({ size }) => (size ? size : '20px')};
      height: ${({ size }) => (size ? size : '20px')};
      transition: all 0.3s ease-in-out;

      animation: ${spinnerAnimation} 0.6s linear infinite;

      @media (max-width: 640px) {
         width: ${({ $mobilesize }) => ($mobilesize ? $mobilesize : '20px')};
         height: ${({ $mobilesize }) => ($mobilesize ? $mobilesize : '20px')};
         transition: all 0.3s ease-in-out;
      }
   }
`;

export default IconsLib;

// const IconsLib = ({
//    id = '',
//    icon = 'heart-fill',
//    size,
//    color,
//    flip,
//    hovercolor = '',
//    mobilesize = '14px',
// }: Props) => {
//    switch (icon) {
//       case 'user-line':
//          return (
//             <Wrapper
//                id={id}
//                //    icon={icon}
//                flip={flip}
//                $hovercolor={hovercolor} // Use transient prop $
//                $mobilesize={mobilesize} // Use transient prop $
//                size={size}
//                color={color}
//             >
//                <RiUserLine
//                   size={size}
//                   // color={color}
//                   className="iconlist_item_icon" // add custom class name
//                />
//             </Wrapper>
//          );
//       case 'user-fill':
//          return (
//             <Wrapper
//                id={id}
//                //    icon={icon}
//                flip={flip}
//                $hovercolor={hovercolor} // Use transient prop $
//                $mobilesize={mobilesize} // Use transient prop $
//                size={size}
//                color={color}
//             >
//                <RiUserFill
//                   size={size}
//                   // color={color}
//                   className="iconlist_item_icon" // add custom class name
//                />
//             </Wrapper>
//          );
//       case 'store-3-line':
//          return (
//             <Wrapper
//                id={id}
//                //    icon={icon}
//                flip={flip}
//                $hovercolor={hovercolor} // Use transient prop $
//                $mobilesize={mobilesize} // Use transient prop $
//                size={size}
//                color={color}
//             >
//                <RiStore3Line
//                   size={size}
//                   // color={color}
//                   className="iconlist_item_icon" // add custom class name
//                />
//             </Wrapper>
//          );
//       case 'store-3-fill':
//          return (
//             <Wrapper
//                id={id}
//                //    icon={icon}
//                flip={flip}
//                $hovercolor={hovercolor} // Use transient prop $
//                $mobilesize={mobilesize} // Use transient prop $
//                size={size}
//                color={color}
//             >
//                <RiStore3Fill
//                   size={size}
//                   // color={color}
//                   className="iconlist_item_icon" // add custom class name
//                />
//             </Wrapper>
//          );
//       case 'bank-card-line':
//          return (
//             <Wrapper
//                id={id}
//                //    icon={icon}
//                flip={flip}
//                $hovercolor={hovercolor} // Use transient prop $
//                $mobilesize={mobilesize} // Use transient prop $
//                size={size}
//                color={color}
//             >
//                <RiBankCardLine
//                   size={size}
//                   // color={color}
//                   className="iconlist_item_icon" // add custom class name
//                />
//             </Wrapper>
//          );
//       case 'bank-card-fill':
//          return (
//             <Wrapper
//                id={id}
//                //    icon={icon}
//                flip={flip}
//                $hovercolor={hovercolor} // Use transient prop $
//                $mobilesize={mobilesize} // Use transient prop $
//                size={size}
//                color={color}
//             >
//                <RiBankCardFill
//                   size={size}
//                   // color={color}
//                   className="iconlist_item_icon" // add custom class name
//                />
//             </Wrapper>
//          );
//       case 'arrow-left-right-line':
//          return (
//             <Wrapper
//                id={id}
//                //    icon={icon}
//                flip={flip}
//                $hovercolor={hovercolor} // Use transient prop $
//                $mobilesize={mobilesize} // Use transient prop $
//                size={size}
//                color={color}
//             >
//                <RiArrowLeftRightLine
//                   size={size}
//                   // color={color}
//                   className="iconlist_item_icon" // add custom class name
//                />
//             </Wrapper>
//          );

//       case 'arrow-left-right-fill':
//          return (
//             <Wrapper
//                id={id}
//                //    icon={icon}
//                flip={flip}
//                $hovercolor={hovercolor} // Use transient prop $
//                $mobilesize={mobilesize} // Use transient prop $
//                size={size}
//                color={color}
//             >
//                <RiArrowLeftRightFill
//                   size={size}
//                   // color={color}
//                   className="iconlist_item_icon" // add custom class name
//                />
//             </Wrapper>
//          );
//       case 'coupon-line':
//          return (
//             <Wrapper
//                id={id}
//                //    icon={icon}
//                flip={flip}
//                $hovercolor={hovercolor} // Use transient prop $
//                $mobilesize={mobilesize} // Use transient prop $
//                size={size}
//                color={color}
//             >
//                <RiCouponLine
//                   size={size}
//                   // color={color}
//                   className="iconlist_item_icon" // add custom class name
//                />
//             </Wrapper>
//          );
//       case 'coupon-fill':
//          return (
//             <Wrapper
//                id={id}
//                //    icon={icon}
//                flip={flip}
//                $hovercolor={hovercolor} // Use transient prop $
//                $mobilesize={mobilesize} // Use transient prop $
//                size={size}
//                color={color}
//             >
//                <RiCouponFill
//                   size={size}
//                   // color={color}
//                   className="iconlist_item_icon" // add custom class name
//                />
//             </Wrapper>
//          );
//       case 'home-5-line':
//          return (
//             <Wrapper
//                id={id}
//                //    icon={icon}
//                flip={flip}
//                $hovercolor={hovercolor} // Use transient prop $
//                $mobilesize={mobilesize} // Use transient prop $
//                size={size}
//                color={color}
//             >
//                <RiHome5Line
//                   size={size}
//                   // color={color}
//                   className="iconlist_item_icon" // add custom class name
//                />
//             </Wrapper>
//          );
//       case 'home-5-fill':
//          return (
//             <Wrapper
//                id={id}
//                //    icon={icon}
//                flip={flip}
//                $hovercolor={hovercolor} // Use transient prop $
//                $mobilesize={mobilesize} // Use transient prop $
//                size={size}
//                color={color}
//             >
//                <RiHome5Fill
//                   size={size}
//                   // color={color}
//                   className="iconlist_item_icon" // add custom class name
//                />
//             </Wrapper>
//          );
//       case 'heart-fill':
//          return (
//             <Wrapper
//                id={id}
//                //    icon={icon}
//                flip={flip}
//                $hovercolor={hovercolor} // Use transient prop $
//                $mobilesize={mobilesize} // Use transient prop $
//                size={size}
//                color={color}
//             >
//                <RiHeartFill
//                   size={size}
//                   // color={color}
//                   className="iconlist_item_icon" // add custom class name
//                />
//             </Wrapper>
//          );
//       case 'check-circle-line':
//          return (
//             <Wrapper
//                id={id}
//                //    icon={icon}
//                flip={flip}
//                $hovercolor={hovercolor} // Use transient prop $
//                $mobilesize={mobilesize} // Use transient prop $
//                size={size}
//                color={color}
//             >
//                <RiCheckboxCircleLine
//                   size={size}
//                   // color={color}
//                   className="iconlist_item_icon" // add custom class name
//                />
//             </Wrapper>
//          );
//       case 'mail-line':
//          return (
//             <Wrapper
//                id={id}
//                //    icon={icon}
//                flip={flip}
//                $hovercolor={hovercolor} // Use transient prop $
//                $mobilesize={mobilesize} // Use transient prop $
//                size={size}
//                color={color}
//             >
//                <RiMailLine
//                   size={size}
//                   // color={color}
//                   className="iconlist_item_icon" // add custom class name
//                />
//             </Wrapper>
//          );
//       case 'error-warning-fill':
//          return (
//             <Wrapper
//                id={id}
//                //    icon={icon}
//                flip={flip}
//                $hovercolor={hovercolor} // Use transient prop $
//                $mobilesize={mobilesize} // Use transient prop $
//                size={size}
//                color={color}
//             >
//                <RiErrorWarningFill
//                   size={size}
//                   // color={color}
//                   className="iconlist_item_icon" // add custom class name
//                />
//             </Wrapper>
//          );
//       default:
//          return (
//             <Wrapper
//                id={id}
//                //    icon={icon}
//                flip={flip}
//                $hovercolor={hovercolor} // Use transient prop $
//                $mobilesize={mobilesize} // Use transient prop $
//                size={size}
//                color={color}
//             >
//                <RiHeartFill
//                   className="iconlist_item_icon" // add custom class name
//                />
//             </Wrapper>
//          );
//    }
// };
